import { MeetingsPage } from "@/components/Meetings/MeetingsPage";

export function Meetings() {
  return <MeetingsPage />;
}
